import { IconButton, Typography, Tooltip } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import { useContext, useEffect, useState } from "react"
import { containerEntregaMultipla, styleDestinatario, styleIcons, sxImovelEntregaMultipla, styleAddRemove } from "./sxEntregaMultipla"
import { CondominiosContext } from "../../../../../Providers/CondominiosContext/CondominiosContext"
import AutoCompleteImovel from "../../AutoCompleteImovel/AutoCompleteImovel"
import { WebSocketContext } from "../../../../../Providers/WebSocket/WebSocketContext"
import AutoCompleteMoradores from "../../../../GestaoEventos/AutoCompleteMoradores/AutoCompleteMoradores"
import OneButton from "../../../../../Components/OneButton/OneButton"
import { Check, Add, Remove, DeleteOutline } from "@mui/icons-material"
import { showNotify } from "../../../../../Utils/Utils"
import { filtrosTypography } from "../../PeocuraEntregas/sxPeocuraEntregas"
import { EncomendaContex } from "../../../../../Providers/EncomendaContext/EncomendaContext"
import ListaItensOrigem from "../ListaItensOrigem/ListaItensOrigem"

const EntregaMultipla = ({ openModalEntregaMultipla, setOpenModalEntregaMultipla }) => {
    const { activeCond } = useContext(CondominiosContext)
    const { sendWs, addRoute } = useContext(WebSocketContext)
    const { procurarEncomenda } = useContext(EncomendaContex)

    const [count, setCount] = useState(Array.from({ length: 5 }, (_, index) => index))
    const [imoveisSelecionado, setImoveisSelecionado] = useState([])
    const [formData, setFormData] = useState([])
    const [imoveis, setImoveis] = useState([])
    const [selectedOrigin, setSelectedOrigin] = useState(null)

    const [enabledIndexes, setEnabledIndexes] = useState([])

    const getImovel = (msg) => {
        let imoveis
        if (msg.data.status && Array.isArray(msg.data.imoveis.dados)) {
            imoveis = msg.data.imoveis.dados
            let novoImovel = []
            imoveis.map((imovel) => {
                let objeto = {
                    id: imovel.id,
                    descricao: imovel.unidade1 + ' - ' + imovel.unidade2
                }
                novoImovel.push(objeto)
            })
            setImoveis(novoImovel)
        }
    }

    useEffect(() => {
        if (activeCond && activeCond.id_central) {
            sendWs("getImovel", { id_central: activeCond.id_central })
            addRoute("getImovel", getImovel)
        }
    }, [])

    const adicionaComponete = () => {
        setCount(prevCount => [...prevCount, prevCount.length])
    }

    const removeComponete = () => {
        setCount(prevCount => prevCount.slice(0, -1))
        let ultimaPosition = count.length - 1

        let updatedImoveisSelecionado = imoveisSelecionado.filter(item => item.index !== ultimaPosition)
        setImoveisSelecionado([...updatedImoveisSelecionado])

        let updatedEncomendas = formData.encomendas.filter(item => item.index !== ultimaPosition)
        let updatedImoveis = formData.imoveis.filter(item => item.index !== ultimaPosition)

        setFormData({
            ...formData,
            encomendas: updatedEncomendas,
            imoveis: updatedImoveis
        })
    }

    const removeComponeteEspecifico = (index) => {
        setCount(prevCount => prevCount.filter(item => item !== index))
        setImoveisSelecionado(prevImoveis => prevImoveis.filter(item => item.index !== index))
        setFormData(prevFormData => ({
            ...prevFormData,
            encomendas: prevFormData.encomendas.filter(item => item.index !== index),
            imoveis: prevFormData.imoveis.filter(item => item.index !== index)
        }))
    }

    const handleChangeImoveis = (e, index) => {
        if (e.target.name === 'imovel') {
            let newImoveis = e.target.value

            let obj = {
                index,
                id_imovel: newImoveis
            }
            let updatedImoveisSelecionado = imoveisSelecionado.filter(item => item.index !== index)

            setImoveisSelecionado([...updatedImoveisSelecionado, obj])
            setFormData(prev => {
                const existingEncomendaIndex = prev.imoveis?.findIndex(item => item.index === index)

                let updatedimoveis

                if (existingEncomendaIndex !== -1 && existingEncomendaIndex !== undefined) {
                    updatedimoveis = [...prev.imoveis]
                    updatedimoveis[existingEncomendaIndex] = obj
                } else {
                    updatedimoveis = prev.imoveis ? [...prev.imoveis, obj] : [obj]
                }

                return {
                    ...prev,
                    imoveis: updatedimoveis
                }
            })
            setEnabledIndexes((prevIndexes) => {
                if (!prevIndexes.includes(index)) {
                    return [...prevIndexes, index]
                }
                return prevIndexes
            })
        }
    }

    const handleChangeMoradores = (e) => {
        let cd_acesso = e.target.cd_acesso
        let index = e.target.index

        if (index != undefined && cd_acesso != undefined) {
            const imovel = imoveisSelecionado.find(item => item.i === index)
            const newEncomenda = imovel ? { index, cd_acesso } : { index, cd_acesso }
            setFormData(prev => {
                const existingEncomendaIndex = prev.encomendas?.findIndex(item => item.index === index)

                let updatedEncomendas

                if (existingEncomendaIndex !== -1 && existingEncomendaIndex !== undefined) {
                    updatedEncomendas = [...prev.encomendas]
                    updatedEncomendas[existingEncomendaIndex] = newEncomenda
                } else {
                    updatedEncomendas = prev.encomendas ? [...prev.encomendas, newEncomenda] : [newEncomenda]
                }

                return {
                    ...prev,
                    encomendas: updatedEncomendas
                }
            })
        } else {
            setFormData(prev => ({ ...prev, encomendas: [], imoveis: [] }))
        }
    }

    const handleSubimit = () => {
        if (!formData) {
            showNotify("warning", "Nenhuma alteração feita!")
            return
        }

        if (formData?.id_encomenda_origem == undefined) {
            showNotify("warning", "Origem é Obrigatorio!")
            return
        }

        let encomendas = []

        if (formData?.encomendas.length > 0) {
            encomendas = formData?.encomendas.map((item) => {
                const { index, ...rest } = item
                return rest
            })
        }

        if (formData?.imoveis.length > 0) {
            formData?.imoveis.forEach((item, idx) => {
                const { index, ...rest } = item

                if (encomendas[idx]) {
                    encomendas[idx] = { ...encomendas[idx], encomenda_futura: 0, ...rest }
                } else {
                    encomendas[idx] = { encomenda_futura: 0, ...rest }
                }
            })
        }

        if (encomendas.length <= 0) {
            showNotify("warning", "É obrigatório selecionar pelo menos um imóvel ou Destinatário!")
            return
        }

        let data = { id_central: activeCond.id_central, id_encomenda_origem: formData?.id_encomenda_origem, encomendas }
        sendWs("CriarEncomendaMultipla", data)
        addRoute("CriarEncomendaMultipla", getMultiplaEntrega)
    }

    const getMultiplaEntrega = (msg) => {
        if (msg.data.status) {
            showNotify('success', 'Entregas registradas com sucesso')
            setOpenModalEntregaMultipla(false)
            setImoveisSelecionado([])
            procurarEncomenda()
        } else {
            setOpenModalEntregaMultipla(false)
            showNotify("warning", "Erro ao tentar criar encomendas!")
        }
    }

    return (
        <Grid xs={12} sm={12} md={12} lg={12} xl={12} sx={containerEntregaMultipla}>

            <Grid xs={12} sm={12} md={12} lg={12} xl={12} container sx={{ gap: '3px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <span style={{ fontSize: '13px', fontWeight: '600', color: 'red' }}>*</span>
                    <Typography sx={{ marginRight: '30px' }}>Origem:</Typography>
                </div>
                <ListaItensOrigem
                    selectedOrigin={selectedOrigin}
                    setSelectedOrigin={setSelectedOrigin}
                    setFormData={setFormData}
                />
            </Grid>

            <Grid xs={12} sm={12} md={12} lg={12} xl={12} sx={styleDestinatario}>
                {
                    count.map(index => (
                        <ListaImovelDestinatario
                            key={index}
                            index={index}
                            imoveis={imoveis}
                            activeCond={activeCond}
                            handleChangeImoveis={(e) => handleChangeImoveis(e, index)}
                            handleChangeMoradores={handleChangeMoradores}
                            imoveisSelecionado={imoveisSelecionado}
                            openModalEntregaMultipla={openModalEntregaMultipla}
                            isDefault={false}
                            disabled={!enabledIndexes.includes(index)}
                            isRequired={index === 0}
                            removeComponeteEspecifico={() => removeComponeteEspecifico(index)}
                        />
                    ))
                }
            </Grid>

            <Grid xs={12} sm={12} md={12} lg={12} xl={12} container sx={styleIcons}>
                <div style={styleAddRemove}>
                    <Tooltip
                        title="Adicionar"
                        arrow
                        placement="top"
                        slotProps={{
                            popper: {
                                modifiers: [
                                    {
                                        name: 'offset',
                                        options: {
                                            offset: [0, -5]
                                        }
                                    }
                                ]
                            }
                        }}
                    >
                        <IconButton
                            aria-label="add"
                            sx={{ width: '30px', height: '30px' }}
                            onClick={adicionaComponete}
                        >
                            <Add/>
                        </IconButton>
                    </Tooltip>

                    <Tooltip
                        title={ (count.length < 2) ? "É necessário no mínimo 1 item." : "Remover"}
                        arrow
                        placement="top"
                    >
                        <span>
                            <IconButton
                                aria-label="delete"
                                sx={{ width: '30px', height: '30px' }}
                                onClick={removeComponete}
                                disabled={count.length < 2}
                            >
                                <Remove></Remove>
                            </IconButton>
                        </span>
                    </Tooltip>
                </div>

                <Tooltip
                    title={!selectedOrigin || (!imoveisSelecionado.length && formData?.encomendas?.length == 0)
                        ? "É necessário selecionar a ORIGEM e a opção de IMÓVEL"
                        : ""
                    }
                    arrow
                    placement="top"
                >
                    <span>
                        <OneButton
                            disabled={!selectedOrigin || (!imoveisSelecionado.length && formData?.encomendas?.length == 0)}
                            newSx={{ border: '0px' }}
                            color="one_primary"
                            backgroundColor='true'
                            variant="contained"
                            onClick={handleSubimit}
                            IconStart={Check}
                            sxIconStart={{ width: '20px' }}
                        >
                            CONCLUIR
                        </OneButton>
                    </span>
                </Tooltip>
            </Grid>
        </Grid>
    )
}

export const ListaImovelDestinatario = ({ index, imoveis, activeCond, handleChangeImoveis, handleChangeMoradores, imoveisSelecionado, resetMorador, resetImovel, newSx, defaultValue = '', defaultValueImovel = '', isDefault = true, isRequired = false, disabled = false, removeComponeteEspecifico }) => {
    return (
        <Grid xs={12} sm={12} md={12} lg={12} xl={12} container sx={ isDefault ? { padding: '5px' } : { padding: '0px' } }>
            <Grid xs={isDefault ? 6 : 5} sm={isDefault ? 6 : 5} md={isDefault ? 6 : 5} lg={isDefault ? 6 : 5} xl={isDefault ? 6 : 5} sx={sxImovelEntregaMultipla}>
                <Grid xs={isDefault ? 4 : 5} sm={isDefault ? 4 : 5} md={isDefault ? 4 : 5} lg={isDefault ? 4 : 5} xl={isDefault ? 4 : 5} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    {
                        isRequired &&
                        <span style={{ fontSize: '13px', fontWeight: '600', color: 'red' }}>*</span>
                    }
                    <Typography sx={ isDefault ? filtrosTypography : "" }>Imóvel:</Typography>
                </Grid>
                <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
                    {
                        imoveis.length > 0
                            ? <AutoCompleteImovel index={index} imoveis={[{ id: 0, descricao: 'Nenhum imóvel' }, ...imoveis]} handleChangeImoveis={handleChangeImoveis} reset={resetImovel} newSx={newSx} defaultValueImovel={defaultValueImovel}/>
                            : <AutoCompleteImovel index={index} imoveis={[{ id: 0, descricao: 'Nenhum imóvel' }]} handleChangeImoveis={handleChangeImoveis} reset={resetImovel} newSx={newSx} defaultValueImovel={defaultValueImovel}/>
                    }
                </Grid>
            </Grid>

            <Grid xs={6} sm={6} md={6} lg={6} xl={6} gap={!isDefault ? 1 : 0} sx={sxImovelEntregaMultipla} >
                <Grid xs={5} sm={5} md={5} lg={5} xl={5}>
                    <Typography sx={ isDefault ? filtrosTypography : "" }>Destinatario:</Typography>
                </Grid>
                <Grid xs={8} sm={8} md={8} lg={8} xl={8}>
                    <AutoCompleteMoradores
                        key={index}
                        index={index}
                        condominio={activeCond.id_central}
                        callback={handleChangeMoradores}
                        imoveisSelecionado={imoveisSelecionado}
                        reset={resetMorador}
                        defaultValue={defaultValue}
                        disableByOtherComp={disabled}
                    />
                </Grid>
                {!isDefault && removeComponeteEspecifico &&
                    <Grid xs>
                        <Tooltip title='Remover linha' placement="bottom" arrow>
                            <DeleteOutline onClick={() => removeComponeteEspecifico(index)} sx={{ cursor: 'pointer' }}/>
                        </Tooltip>
                    </Grid>
                }
            </Grid>

        </Grid>
    )
}

export default EntregaMultipla
